import { format } from 'date-fns'

import {
  CALENDAR_GRID_LABEL_SEPARATOR,
  CalendarGridMode,
} from '../../../constants/calendarGrid'
import {
  DATE_MONTH_YEAR_FORMAT,
  DATE_SHORT_FORMAT,
  DATE_WEEKDAY_SHORT_FORMAT,
} from '../../../constants/date'
import { CALENDAR_GRID_RANGE_SEPARATOR } from '../CalendarGrid.constants'
import {
  formatCalendarGridDay,
  getCalendarGridWeekNumber,
} from '../CalendarGrid.utils'

function getCalendarGridDaysSpanLabel(days) {
  return [days[0], days[days.length - 1]]
    .map(day =>
      formatCalendarGridDay({ dateFormat: DATE_SHORT_FORMAT, day: day.date })
    )
    .join(CALENDAR_GRID_RANGE_SEPARATOR)
}

export function getCalendarGridRangeLabel({ anchor, days, locale, mode, t }) {
  switch (mode) {
    case CalendarGridMode.month:
      return format(anchor, DATE_MONTH_YEAR_FORMAT, { locale })
    case CalendarGridMode.day:
      return format(anchor, DATE_WEEKDAY_SHORT_FORMAT, { locale })
    case CalendarGridMode.agenda:
      return [
        t('Calendar.AgendaRangeKey'),
        getCalendarGridDaysSpanLabel(days),
      ].join(CALENDAR_GRID_LABEL_SEPARATOR)
    default:
      return [
        t('Calendar.WeekNumberKey', {
          week: getCalendarGridWeekNumber(days[0]),
        }),
        getCalendarGridDaysSpanLabel(days),
      ].join(CALENDAR_GRID_LABEL_SEPARATOR)
  }
}

export function getIsCalendarGridModeActive({ mode, modeName }) {
  return modeName === mode
}
